// extracted by mini-css-extract-plugin
module.exports = {"badge":"ToggleBadge_badge__1QcbD"};